import axios from '../../axios-atis'

import * as actionTypes from './actionTypes';

export const fetchDocumentsBegin = () => ({
    type : actionTypes.FETCH_DOCUMENTS_BEGIN
});

export const fetchDocumentsSuccess =  documents  => {
    return {
        type: actionTypes.FETCH_DOCUMENTS_SUCCESS,
        payload: { documents }
    }
};

export const fetchDocumentsError = error => {
    return {
        type: actionTypes.FETCH_DOCUMENTS_FAILED,
        payload: { error }
    };
};
export const fetchDocuments = (path) => {
    return dispatch => {
        dispatch(fetchDocumentsBegin());
        var postUrl = "";
        if (path!=null) {
            postUrl = "?path="+path
        }
        
        let url = '/documents'+postUrl;
        axios.get(url)
            .then(response => {
                dispatch(fetchDocumentsSuccess(response.data));
            })
            .catch(err => {
                dispatch(fetchDocumentsError(err));
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/document.js